import React from 'react';

import styles from './styles/guide-box.module.css';

export default function GuideBox({ guideMap }) {
    return (
        <ul className={styles.wrapper}>
            {guideMap.map((guide, index) => (
                <li key={index}>{guide}</li>
            ))}
        </ul>
    );
}
